import Grid from '@components/layout/grid';
import { Spotlight } from '../../components/ui/Spotlight';
import { TextGenerateEffect } from '../../components/ui/TextGenerateEffect';
import { MyProfileData } from '@constants/index';
import OpenToWorkStatus from '@components/OpenToWorkStatus';
import RecentProjects from '@components/RecentProjects';
import WorkExperience from '@components/Experience';
import Approach from '@components/Approach';
import Certs from '@components/Certs';
import Footer from '@components/Unique/Footer';
import MagicButton from '@components/buttons/magicButton';

const HomeHeader = () => {
  return (
    <>
      <div className="flex justify-center relative mt-5">
        <img
          src="/loader_sinrotacion.gif"
          className="max-w-[150px] max-h-[150px] rounded-lg relative z-10"
          alt="Loader"
        />
      </div>
      <div className="flex justify-center relative my-10 z-20 \">
        <div className="max-w-[89vw] md:max-w-2xl lg:max-w-[60vw] flex flex-col items-center justify-center">
          <p className="uppercase pb-4 tracking-widest text-xs text-center text-blue-100 max-w-80">
            Welcome to my profile, take a seat
          </p>

          <OpenToWorkStatus isOpenToWork={false} />

          {/**
           *  Link: https://ui.aceternity.com/components/text-generate-effect
           *
           *  change md:text-6xl, add more responsive code
           */}
          <TextGenerateEffect
            words="Transforming Concepts into Seamless User Experiences"
            className="text-center text-[40px] md:text-5xl lg:text-6xl"
          />

          <p className="text-center md:tracking-wider mb-4 text-sm md:text-lg lg:text-2xl">
            Hi! I&apos;m Sam, a Software Engineer based in Mexico.
          </p>

          <a href="#projects">
            <MagicButton
              title="Show my work"
              // icon={<FaLocationArrow />}
              // position="right"
            />
          </a>
        </div>
      </div>
    </>
  );
};

const PageHome = () => {
  return (
    <div className="pb-20 pt-10">
      <div>
        <Spotlight className="-top-40 -left-10 md:-left-32 md:-top-20 h-screen" fill="white" />
        <Spotlight className="top-10 left-[80%] translate-x-1/2 h-[80vh] w-[50vw]" fill="purple" />
        <Spotlight className="left-80 top-28 h-[80vh] w-[50vw]" fill="blue" />
      </div>
      <HomeHeader />
      {/**
       *  UI: grid
       *  change bg color to bg-black-100 and reduce grid color from
       *  0.2 to 0.03
       */}
      <div className="w-full relative  dark:bg-black-100  bg-white dark:bg-grid-white/[0.3] bg-grid-black/[0.2]">
        <Grid data={MyProfileData} />

        <div
          className="absolute pointer-events-none inset-0 flex items-center justify-center dark:bg-black-100
         bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)]"
        />
      </div>
      <section id="projects">
        <RecentProjects />
      </section>

      <section id="experience">
        <WorkExperience />
      </section>

      <section id="approach">
        <Approach />
      </section>

      <section id="certs">
        <Certs />
      </section>

      <Footer />
    </div>
  );
};

export default PageHome;
